module.exports = __webpack_public_path__ + "static/bioclimatica-45e72cc3b9ed5327586f310b179f8084.png";